import SvgIcon from '@/pages/home/components/SvgIcon';
import { TablePipeline, features } from 'ali-react-table';
import React from 'react';
import { isEmpty } from 'lodash-es';
export interface ItemOrder {
  code: string;
  order: string;
}
/**
 * 前端纯分页处理
 * @param array  传入的数据源
 * @param size   数据源size大小
 * @returns 返回切割后的二维新数组
 */
export const getPagingInterception = (array: string | any[], size: number) => {
  const length = array?.length;
  if (!length || !size || size < 1) {
    return [];
  }
  let index = 0; // 用来表示切割元素的范围start
  let resIndex = 0; // 用来递增表示输出数组的下标
  const result = new Array(Math.ceil(length / size));
  // 进行循环
  while (index < length) {
    // eslint-disable-next-line no-plusplus
    result[resIndex++] = array.slice(index, (index += size));
  }
  return result;
};

// 增加序号
export const serialNumberHandler = () => (pipeline: TablePipeline) => pipeline.mapColumns((cols) => [
  {
    name: '序号',
    lock: true,
    width: 60,
    align: 'center',
    getValue: (row, rowIndex) => rowIndex + 1,
  },
  ...cols,
]);

// 增加排序箭头
export const serialSortHandler = (
  keepDataSource: boolean,
  onChangeSorts: (...args: any[]) => void,
  sorts?: ItemOrder[] | undefined,
  isOpenSortMultiple?: boolean
) => (pipeline: TablePipeline) => {
  let cloneDeepList: ItemOrder[] = [];
  return pipeline.use(
    features.sort({
      mode: isOpenSortMultiple ? 'multiple' : 'single',
      clickArea: 'content',
      orders: ['desc', 'asc', 'none'],
      ...(!isEmpty(sorts) ? sorts : {}),
      onChangeSorts: (value) => {
        onChangeSorts?.(value);
        cloneDeepList = value;
      },
      keepDataSource: keepDataSource || false,
      SortHeaderCell: (props: any) => {
        // eslint-disable-next-line react/prop-types, @typescript-eslint/no-unused-vars
        const { sortOrder, onToggle,column, ...rest } = props;
        const sortCfg = {
          desc: 'arrow-big-down',
          asc: 'arrow-big-up',
          none: 'sort-icon',
        }[sortOrder as string] || 'sort-icon';
        return (
          <>
            <div onClick={(e) => {
              onToggle(e);
              onChangeSorts(cloneDeepList, { code: column.code, order: sortOrder });
            }}
            // eslint-disable-next-line no-nested-ternary
            style={{ justifyContent: column.align === 'right' ? 'flex-end' : column.align === 'center' ? 'center' : '' }}
            // eslint-disable-next-line
            className={`db-alitable_sortbtn ${sortOrder !== 'none' ? 'is-active' : ''} ${column.align === 'right' ? 'db-text-right' : ""}`}>
              <span className='db-alitable_sortbtn-text'>{props.children}</span>
              <SvgIcon className='db-alitable_sortbtn-icon' type={sortCfg} />
            </div>
          </>
        );
      },
    }),
  );
};


// ali组件多列排序有差异，源码是采用点击下标来获取多列顺序，会导致多列排序时，其他列没有点击，也会受影响，index变成-1
/**
 * 
 * @param array1 原数组
 * @param array2 比较数组
 * @param deleteItem 需要删除的对象
 * @returns 返回全新结合的数组
 */
export const combineArrays = (array1: ItemOrder[], array2: ItemOrder[], deleteItem: ItemOrder): ItemOrder[] => {
  let mergedArray = array1.map(item1 => {
    for (const item2 of array2) {
      if (item1.code === item2.code) {
        return { ...item2 };
      }
    }
    return item1;
  });

  array2?.forEach(item2 => {
    if (!mergedArray.some(item1 => item1.code === item2.code)) {
      mergedArray.push({ ...item2 });
    }
  });

  if (deleteItem) {
    const { code, order } = deleteItem;
    if (order === 'asc') {
      mergedArray = mergedArray.filter(item => !(item.code === code && item.order === 'asc'));
    }
  }

  return mergedArray;
};